module.exports = __webpack_public_path__ + "img/task1088.7c91d55b.png";